<template>
  <td>
    <div
      v-if="!status"
      @click="updateStatus"
      class="v-input v-input--selection-controls v-input--switch theme--light"
    >
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-input--selection-controls__input">
            <input aria-checked="false" role="checkbox" type="checkbox" />
            <div class="v-input--selection-controls__ripple" />
            <div class="v-input--switch__track theme--light" />
            <div class="v-input--switch__thumb theme--light" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      @click="updateStatus"
      class="v-input v-input--selection-controls v-input--switch v-input--is-label-active v-input--is-dirty theme--light"
    >
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-input--selection-controls__input">
            <input aria-checked="true" role="checkbox" type="checkbox" />
            <div class="v-input--selection-controls__ripple accent--text" />
            <div class="v-input--switch__track theme--light accent--text" />
            <div class="v-input--switch__thumb theme--light accent--text" />
          </div>
        </div>
      </div>
    </div>
  </td>
</template>

<script>
  export default {
    props: {
      campaign: {
        type: Object
      },
      status: {
        type: Boolean
      },
      id: {
        type: String
      }
    },
    data () {
      return {}
    },
    methods: {
      updateStatus () {
        this.$emit('updateStatus', this.campaign.id, false)
      }
    }
  }
</script>
